export default __webpack_public_path__ + "static/media/Slide16.90dea6e9.JPG";